import { Form, Modal, Select } from "antd"
import React, { useEffect, useState } from "react"
import { User, apiFetchUsersInCompany } from "../../../containers/QueryBuilder/queryBuilderApi"

const { Option } = Select

interface Props {
    isOpen: boolean
    setOpen: (open: boolean) => void
    usersString: string | null
    callback: (usersString: string) => void
}

const UsersDialog = ({ isOpen, setOpen, usersString, callback }: Props) => {

    const [form] = Form.useForm()
    const [logins, setLogins] = useState<User[]>([])

    useEffect(() => {
        apiFetchUsersInCompany()
            .then(i => setLogins(i))
    }, [])

    const handleOk = () => {
        setOpen(false)
        form.submit()
    }

    const handleCancel = () => {
        setOpen(false)
    }

    const onFinish = (formData: any) => {
        callback(form.getFieldValue('users').join(' '))
    }

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo)
    }

    const users = usersString ? usersString.split(' ') : []

    return (<Modal
        title={'Users'}
        onOk={handleOk}
        onCancel={handleCancel}
        open={isOpen}
    >
        <Form
            form={form}
            name="basic"
            style={{ width: '100%' }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            initialValues={{ users: users }}
        >
            <Form.Item name='users'>
                <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder='Select Users'
                    filterOption={(input, option) => {
                        return option ? option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0 : false
                    }}
                >
                    {logins ? logins
                        .map(i => {
                            const title = `${i.name} (${i.login})`
                            return <Option key={i.login} title={title} value={i.login}>{title}</Option>
                        }) : null}
                </Select>
            </Form.Item>
        </Form>
    </Modal>
    )
}

export default UsersDialog